import fetch from './toFetch';

export default {
  /**
   * [getUserInfo 获取用户信息]
   * @return  {[type]}           [return description]
   */
  getUserInfo() {
    return fetch(`/api/api.php?c=index&a=userinfo`, {}, {
      type: 'GET'
    });
  },
  /**
   * [getZone 获取区服列表]
   * @return  {[type]}           [return description]
   */
  getZone() {
    return fetch(`/api/api.php?c=index&a=zonelist`);
  },
  getRole(zone_num) {
    return fetch(`/api/api.php?c=index&a=charlist`, {zone_num}, {
      type: 'GET'
    });
  },
  getPrizeList() {
    return fetch(`/api/api.php?c=index&a=prizelist`, {}, {
      type: 'GET'
    });
  },
  bindRole({zone_num, role_id}) {
    return fetch(`/api/api.php?c=index&a=charbind`, {zone_num, role_id}, {
      type: 'POST'
    });
  },
  draw(ids) { //1=胜 2=平 3=负
    return fetch(`/api/api.php?c=index&a=getprize`, {ids}, {
      type: 'POST'
    });
  },
  /**
   * [lotto 十连抽]
   * @return  {[type]}  [return description]
   */
  lotto() {
    return fetch(`/api/api.php?c=index&a=lotto`, {}, {
      type: 'POST'
    });
  },
  getFriendPrize(fid) {
    return fetch(`/api/api.php?c=index&a=finfo`, {fid}, {
      type: 'GET'
    });
  },
  helpFriend(fid, id) {
    return fetch(`/api/api.php?c=index&a=help`, {fid, id}, {
      type: 'POST'
    });
  },
  getLuckyList() {
    return fetch(`/api/api.php?c=index&a=luckylist`, {}, {
      type: 'GET'
    });
  }
}
